import { siteGroupWeatherConfigurationSelector } from '@sophocles/entities/SiteGroupWeatherConfiguration';
import { createSelector } from 'reselect';

export const siteGroupSelector = state => state.entities.siteGroups;

export const getSiteGroupsWithWeatherConfiguration = createSelector(
  siteGroupSelector,
  siteGroupWeatherConfigurationSelector,
  (siteGroups, weatherConfigurations) => {
    let siteGroupMaps = siteGroups; // .map( (group) => group.toMap() );
    weatherConfigurations.forEach(config => {
      siteGroupMaps = siteGroupMaps.setIn([config.get('site_group') + '', 'weather_configuration'], config);
    });

    return siteGroupMaps;
  },
);
